import ViewRestaurantEquipment from '../../assets/view_restaurants_equipment.mp4';
import CreateEquipmentTicket from '../../assets/create_equipment_ticket.mp4';
import { IntroductionInterface } from '../../interfaces/IntroductionInterface';

export const equipmentFeatureSlides: IntroductionInterface[] = [
  {
    id: 'slide_1',
    header: `View Your Restaurant's Equipment`,
    headerMobile: `View Your Restaurant's Equipment`,
    title: `See your equipment's model, manufacturer, serial number, and warranty information.`,
    titleMobile: `See your equipment's model, manufacturer, serial number, and warranty information.`,
    video: ViewRestaurantEquipment,
    alt: 'View Restaurant Equipment Video',
    qrCode: true,
    kbArticle: undefined,
  },
  {
    id: 'slide_2',
    header: 'Create Equipment Tickets More Easily',
    headerMobile: 'Create Equipment Tickets More Easily',
    title:
      'Open a ticket from the equipment screen to auto-fill the equipment type and serial number.',
    titleMobile:
      'Open a ticket from the equipment screen to auto-fill the equipment type and serial number.',
    video: CreateEquipmentTicket,
    alt: 'Create Equipment Ticket Image',
    kbArticle: undefined,
  },
];
